// Unit toggle for the PØM size guide modal — swaps which pre-rendered value
// (in vs. cm) is visible per table-wrap via a data attribute; no recompute.
document.addEventListener('click', function (evt) {
  var btn = evt.target.closest('.size-guide-unit-btn');
  if (!btn) return;

  var wrap = btn.closest('.size-guide-modal__content');
  if (!wrap) return;

  var unit = btn.dataset.unit;
  var tableWrap = wrap.querySelector('.size-guide-modal__table-wrap');
  if (tableWrap) tableWrap.setAttribute('data-unit', unit);

  wrap.querySelectorAll('.size-guide-unit-btn').forEach(function (b) {
    b.classList.toggle('is-active', b === btn);
  });
});
